/* eslint-disable no-console */
import type {Dispatch} from 'react';
import React, {
	useReducer,
	createContext,
	useCallback,
	useRef,
	useEffect,
} from 'react';

import type {MainAppState, MainAppAction} from './types';
import {mainReducer, getDefaultState} from './reducer';

export const StateContext = createContext<MainAppState>(getDefaultState());
export const DispatchContext = createContext<Dispatch<MainAppAction>>(
	() => void 0,
);

const MainContextProvider = ({children}: {children: React.ReactNode}) => {
	const [state, _dispatch] = useReducer(mainReducer, getDefaultState());
	const previousState = useRef(state);

	const dispatch: Dispatch<MainAppAction> = useCallback(
		(action: MainAppAction) => {
			if (process.env.NODE_ENV === 'development') {
				console.log('%cMain App State', 'color: #AA2233;');
				console.log('oldState:', previousState.current);
				console.log('action:', action);
			}
			_dispatch(action);
		},
		[],
	);

	useEffect(() => {
		if (process.env.NODE_ENV === 'development') {
			console.log('newState:', state);
			console.log('%c---------------------', 'color: #AA2233;');
		}
		previousState.current = state;
	}, [state]);

	return (
		<DispatchContext.Provider value={dispatch}>
			<StateContext.Provider value={state}>{children}</StateContext.Provider>
		</DispatchContext.Provider>
	);
};

export default MainContextProvider;
